var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.showSpinner
    ? _c(
        "div",
        { staticClass: "form-container" },
        [
          _vm.showDropDown
            ? _c(
                "div",
                {
                  staticClass: "dropDown mg mg--t-4 mg--b-4",
                  on: {
                    click: function ($event) {
                      _vm.formIsOpen = !_vm.formIsOpen
                    },
                  },
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.categoryLiteral))]),
                  _c("svgicon", {
                    class: { formIsOpen: _vm.formIsOpen },
                    attrs: {
                      name: "arrow_down",
                      color: "#7E8994",
                      height: "16",
                      width: "16",
                    },
                  }),
                ],
                1
              )
            : _vm.showLiteral
            ? _c("div", { staticClass: "dropDown mg mg--t-4 mg--b-4" }, [
                _c("p", [_vm._v(_vm._s(_vm.categoryLiteral))]),
              ])
            : _vm._e(),
          _c("transition", { attrs: { name: "fade" } }, [
            _vm.formIsOpen
              ? _c("div", { staticClass: "form" }, [
                  _c(
                    "div",
                    { staticClass: "grid" },
                    [
                      _vm.categoryLiteral === "Murs"
                        ? _c(
                            "div",
                            { staticClass: "counterInput grid__cell-md-4" },
                            [
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "headline-medium black mg mg--b-2",
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("formContainer.mursTitle"))
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-counter grid grid--ai-middle mg mg--b-2",
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.stateWarrantyCounterMurs === 1,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mutStateWarrantyUpdateMursCount(
                                            -1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("svgicon", {
                                        staticClass: "counter-btn",
                                        attrs: {
                                          name: "minus",
                                          color: "#566473",
                                          height: "18",
                                          width: "18",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "headline-large mg mg--l-3 mg--r-3",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.stateWarrantyCounterMurs)
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "button",
                                    {
                                      attrs: {
                                        disabled:
                                          _vm.stateWarrantyCounterMurs === 4,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.mutStateWarrantyUpdateMursCount(
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("svgicon", {
                                        staticClass: "counter-btn",
                                        attrs: {
                                          name: "plus",
                                          color: "#566473",
                                          height: "18",
                                          width: "18",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._l(_vm.formData.regions, function (group) {
                        return _c(
                          "div",
                          { staticClass: "grid__row" },
                          [
                            group.label
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "headline-medium black mg mg--b-2",
                                  },
                                  [_vm._v(_vm._s(group.label))]
                                )
                              : _vm._e(),
                            _vm._t("inputForms", function () {
                              return [
                                _vm._l(group.inputs, function (input) {
                                  return [
                                    input.type === "text"
                                      ? _c("ma-input-text", {
                                          attrs: {
                                            type: "text",
                                            category: _vm.categoryTitle,
                                            name: input.name,
                                            "data-name": input.name,
                                            col: "4",
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            value: input.selectedValue,
                                            disabled: input.disabled,
                                          },
                                          on: {
                                            change: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              $event.preventDefault()
                                              input.selectedValue = $event
                                              _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                    input.type === "textDescription"
                                      ? _c("ma-input-textDescription", {
                                          ref: "textDescription",
                                          refInFor: true,
                                          attrs: {
                                            type: "text",
                                            category: _vm.categoryTitle,
                                            name: input.name,
                                            "data-name": input.name,
                                            col: "4",
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            value: input.selectedValue,
                                            disabled: input.disabled,
                                          },
                                          on: {
                                            input: function ($event) {
                                              input.selectedValue = $event
                                              _vm.handleEventDelay(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "textNumbers" &&
                                        input.name !== "ROOM_SURFACE"
                                      ? _c("ma-input-text-numbers", {
                                          ref: "textNumbers",
                                          refInFor: true,
                                          attrs: {
                                            type: "text",
                                            inputmode: "decimal",
                                            category: _vm.categoryTitle,
                                            name: input.name,
                                            col: "4",
                                            "data-name": input.name,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            value: input.selectedValue,
                                            disabled: input.disabled,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              input.selectedValue = $event
                                              _vm.handleEventDelay(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "hidden"
                                      ? _c("ma-input-text", {
                                          attrs: {
                                            category: _vm.categoryTitle,
                                            type: "text",
                                            hidden: true,
                                            name: input.name,
                                            col: input.col,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            agentLiteral: input.agent_literal,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "select" &&
                                        (_vm.agentView === false ||
                                          input.options.length > 10 ||
                                          input.options.length === 1)
                                      ? _c("ma-input-select", {
                                          attrs: {
                                            category: _vm.categoryTitle,
                                            type: "select",
                                            name: input.name,
                                            col: _vm.numberOfColumns(input),
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "select" &&
                                        _vm.agentView === true
                                      ? _c("ma-input-btn", {
                                          attrs: {
                                            type: "radio",
                                            category: _vm.categoryTitle,
                                            "data-name": input.name,
                                            name: input.name,
                                            col: input.col,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            agentLiteral: input.agent_literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "radio"
                                      ? _c("ma-input-btn", {
                                          attrs: {
                                            type: "radio",
                                            name: input.name,
                                            "data-name": input.name,
                                            category: _vm.categoryTitle,
                                            col: input.col,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "imgRadio"
                                      ? _c("ma-input-imgradio", {
                                          attrs: {
                                            type: "imgRadio",
                                            name: input.name,
                                            category: _vm.categoryTitle,
                                            col: input.col,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "checkbox" &&
                                        _vm.agentView === false
                                      ? _c("ma-input-checkbox", {
                                          attrs: {
                                            category: _vm.categoryTitle,
                                            type: "checkbox",
                                            name: input.name,
                                            col: input.col,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "checkbox" &&
                                        _vm.agentView === true
                                      ? _c("ma-input-btn", {
                                          attrs: {
                                            category: _vm.categoryTitle,
                                            type: "checkbox",
                                            name: input.name,
                                            col: input.col,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "textmap" ||
                                        input.type === "textmapline"
                                      ? _c("ma-input-textmap", {
                                          attrs: {
                                            type: "textmap",
                                            name: input.name,
                                            col: input.col,
                                            literal: input.literal,
                                            value: input.selectedValue,
                                            coordinates:
                                              _vm.stateWarrantyCoordinates,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "selectmapline"
                                      ? _c("ma-input-select-map", {
                                          attrs: {
                                            type: "select",
                                            name: input.name,
                                            category: _vm.categoryTitle,
                                            col: input.col,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                            coordinates:
                                              _vm.stateWarrantyCoordinates,
                                            measure: "line",
                                            viewer: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : input.type === "selectmap"
                                      ? _c("ma-input-select-map", {
                                          attrs: {
                                            type: "select",
                                            name: input.name,
                                            col: input.col,
                                            icon: input.icon,
                                            literal: input.self_care_literal
                                              ? input.self_care_literal
                                              : input.literal,
                                            options: input.options,
                                            value: input.selectedValue,
                                            coordinates:
                                              _vm.stateWarrantyCoordinates,
                                            measure: "surface",
                                            viewer: "",
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleEvent(
                                                "change",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                            input: function ($event) {
                                              return _vm.handleEvent(
                                                "input",
                                                input.hasNestedComponents,
                                                input.name,
                                                ...arguments,
                                                _vm.categoryTitle
                                              )
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ]
                                }),
                              ]
                            }),
                          ],
                          2
                        )
                      }),
                      _vm.hasUploadImgs
                        ? _c(
                            "div",
                            { staticClass: "grid__cell-md-4" },
                            [
                              _c("ma-input-file", {
                                attrs: {
                                  category: _vm.categoryTitle,
                                  titleInput: _vm.titleFileInputEnsemble,
                                  name: _vm.nameFileInputEnsemble,
                                  imageList: _vm.inputImgListEnsemble,
                                },
                                on: {
                                  "file:src": function ($event) {
                                    return _vm.handleFileChangeImaEnsemble(
                                      ...arguments,
                                      _vm.categoryTitle
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.hasUploadImgs
                        ? _c(
                            "div",
                            { staticClass: "grid__cell-md-4" },
                            [
                              _c("ma-input-file", {
                                attrs: {
                                  category: _vm.categoryTitle,
                                  titleInput: _vm.titleFileInputPres,
                                  name: _vm.nameFileInputPres,
                                  imageList: _vm.inputImgListPres,
                                },
                                on: {
                                  "file:src": function ($event) {
                                    return _vm.handleFileChangeImgPres(
                                      ...arguments,
                                      _vm.categoryTitle
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
        ],
        1
      )
    : _c("div", { staticClass: "form-container" }, [_c("maSpinner")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }